import {ISDEV} from "./val.js";

export const authConfig = getAuthConfig();

function getAuthConfig() {
  if (ISDEV) {
    console.error(`ISDEV :: ${ISDEV}`);
    return (
      {
        // dev
        region: 'ap-northeast-1',
        userPoolId: 'ap-northeast-1_ogg6fRrUx', //Amazon Cognito User Pool ID
        userPoolWebClientId: '1orunin79kik0gpl05s7o0v78p', //Amazon Cognito Web Client ID
      }
    );
  } else {
    return (
      {
        // prod
        region: 'ap-northeast-1',
        userPoolId: 'ap-northeast-1_R9PaP5XXN', //Amazon Cognito User Pool ID
        userPoolWebClientId: '6ls9nr3cj76lsph6ql2ueo0jjo', //Amazon Cognito Web Client ID
      }
    );
  }
}
